import React, { FC } from 'react'
import { ProductDownloadLogos, ProductDownloadRaisedBox } from '../style'

//* utils
import { ASSETS } from '../../../../constants/assets'
import { internalLinkHandler } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'

//* components
import { RichTextWrapper } from '../../../../styles/global'
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import { GenerateCustomerLogos, GenerateLogos } from './GenerateLogos'

type Props = {
  productDownloadData: any
  handleButtonClick: any
  downloadRef: any
}

export const ProductDownloadContent: FC<Props> = ({
  productDownloadData,
  handleButtonClick,
  downloadRef,
}) => {
  const externalUrl = productDownloadData.externalDownload?.externalUrl
  const internalUrl = productDownloadData.externalDownload?.internalLink

  //* externalDownload takes precedence over fileDownload
  const internalLink = internalUrl ? internalLinkHandler(internalUrl) : ''
  let fileDownload = externalUrl || internalLink || productDownloadData.file?.url
  let fileName = productDownloadData.file?.fileName

  return (
    <>
      <ProductDownloadRaisedBox data-cy="productDownload">
        {productDownloadData.eyebrow && (
          <Typography type="captionAlt" className="ProductDownload__Download-Eyebrow">
            {productDownloadData.eyebrow}
          </Typography>
        )}

        <div className="ProductDownload__Gray-Line"></div>
        <div className="ProductDownload__Download-Products">
          <GenerateLogos productDownloadData={productDownloadData} />
        </div>
        <div className="ProductDownload__Gray-Line"></div>

        {productDownloadData.progressPage && fileDownload && (
          <>
            <a
              ref={downloadRef}
              href={fileDownload}
              download={fileName}
              data-cy="productDownload-File"></a>

            <Button
              icon={true}
              iconFile={
                <WrapperImage
                  className="ProductDownload__Button-Icon"
                  src={ASSETS.DOWNLOAD_ICON}
                  alt="Download icon"
                  threshold={650}
                />
              }
              className="ProductDownload__Download-Button"
              text={productDownloadData.ctaText}
              size="medium"
              arrowOrientation="right"
              type="primary"
              theme="light"
              clickHandler={handleButtonClick}
            />
          </>
        )}

        {productDownloadData.finePrint && (
          <RichTextWrapper $type="caption" className="ProductDownload__Disclaimer">
            {renderRichText(productDownloadData.finePrint)}
          </RichTextWrapper>
        )}
      </ProductDownloadRaisedBox>

      <ProductDownloadLogos>
        <Typography type="caption" className="ProductDownload__Logos-Text">
          {productDownloadData.logosIntro}
        </Typography>

        <div className="ProductDownload__Logos-Container">
          <GenerateCustomerLogos productDownloadData={productDownloadData} />
        </div>

        <Typography type="caption" className="ProductDownload__Logos-Text">
          {productDownloadData.logosOutro}
        </Typography>
      </ProductDownloadLogos>
    </>
  )
}
